import React from 'react';

//Hooks
import {useState} from 'react';

//Contexts
import SignInContext from '../../contexts/SignIn';

const SignInContextProvider = ({children}) => {
    const [disabled, setDisabled] = useState(false);
    const [state, setState] = useState('signIn');
    const [handleSubmit, setHandleSubmit] = useState(null);

    return (
        <SignInContext.Provider value={{
            disabled,
            setDisabled,
            state,
            setState,
            handleSubmit,
            setHandleSubmit
        }}>
            {children}
        </SignInContext.Provider>
    )
};

export default SignInContextProvider